module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24vY3Jvc3MiPgo8cGF0aCBpZD0iVW5pb24iIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzUuMDAwMSA4LjAwMDE2TDMyIDVMMTkuOTk5NCAxNy4wMDA2TDcuOTk5OTkgNS4wMDAwMUw0Ljk5OTk5IDguMDAwM0wxNi45OTkzIDIwLjAwMDdMNC45OTg2NiAzMi4wMDEzTDcuOTk4ODUgMzUuMDAxNUwxOS45OTkzIDIzLjAwMUwzMiAzNS4wMDI5TDM1IDMyLjAwMjZMMjIuOTk5NCAyMC4wMDA5TDM1LjAwMDEgOC4wMDAxNloiIGZpbGw9IiNDMjE5MkIiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cross.svg
// module id = 93ub
// module chunks = 0